import {Component, Input, inject} from '@angular/core';
import {CurrencyPipe, I18nPluralPipe} from '@angular/common';
import {CoverageLevelModel} from 'src/app/models/plans.model';
import {
  MEMBER_DEFINITION_STATEMENT,
  DISPLAYABLE_MEMBER_LIMIT_MIN,
  DISPLAYABLE_MEMBER_LIMIT_MAX,
  FULL_PRICE_PERCENTAGE,
  SAVINGS_PERCENTAGE_DECIMALS
} from '../../../constants/marketing-detail.constants';

@Component({
  selector: 'app-additional-member-savings',
  templateUrl: './additional-member-savings.component.html',
  styleUrls: ['./additional-member-savings.component.scss'],
  providers: [CurrencyPipe, I18nPluralPipe],
  standalone: false
})
export class AdditionalMemberSavingsComponent {
  @Input() public coverageLevel: CoverageLevelModel | undefined = undefined;

  public readonly MEMBER_DEFINITION_STATEMENT: string = MEMBER_DEFINITION_STATEMENT;

  private _currency: CurrencyPipe = inject(CurrencyPipe);

  private _plural: I18nPluralPipe = inject(I18nPluralPipe);

  public get showAdditionalMemberSavings(): boolean {
    return !!this.getAdditionalMemberCostText();
  }

  public getAdditionalMemberCostText(): string {
    const level: CoverageLevelModel | undefined = this.coverageLevel;
    if (!level || level.additionalPersonAmount == null || level.additionalPersonAmount <= 0) {
      return '';
    }
    const amount: number = level.additionalPersonAmount;
    if (!level.isAdditionalPersonPercentage) {
      return `Additional family members are ${this._currency.transform(amount, 'USD', 'symbol', '1.2-2')} per member.`;
    }
    const savingsPercentage: number = this._toSavingsPercentage(amount);
    return savingsPercentage > 0
      ? `Additional family members can save ${savingsPercentage}% when they join your same plan.`
      : '';
  }

  public getMemberLimitText(): string {
    const max: number | null | undefined = this.coverageLevel?.max;
    if (max == null || max < DISPLAYABLE_MEMBER_LIMIT_MIN || max > DISPLAYABLE_MEMBER_LIMIT_MAX) {
      return '';
    }
    return this._plural.transform(max, {
      '=1': 'This plan is limited to 1 member.',
      other: 'This plan is limited to # members.'
    });
  }

  private _toSavingsPercentage(chargedPercentage: number): number {
    return Number((FULL_PRICE_PERCENTAGE - chargedPercentage).toFixed(SAVINGS_PERCENTAGE_DECIMALS));
  }
}
